import { useRef } from 'react';
import Header from "../components/layout/header";
import Footer from "../components/layout/footer";
import Hotline from "../components/common/hotline";
import Register from "../components/common/register";
import styles from "./Home.module.css"

function HomePage() {
  const registerRef = useRef(null);

  const scrollToRegister = () => {
    registerRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });

    // Xoá hash nếu có
    window.history.replaceState(null, "", window.location.pathname);
  };

  return (
    <>
      <Header />

      <div className={styles.homepage}>
        <div className={styles.banner}>
          <img src="/images/banner.jpg" alt="Tuyển sinh du học Hàn Quốc" />
          <div className={styles.header}>
            <h1 className={styles.header_title}>
              Tuyển sinh <br /> Du học Hàn Quốc
            </h1>
            {/* <p className={styles.header_time}>Kỳ tháng 09-12/2025</p> */}
          </div>
          <button className={styles.btn} onClick={scrollToRegister}>Đăng ký ngay</button>
        </div>

        <Hotline />

        <div className={styles.content}>
          <div className={styles.section}>
            <div className={styles.infor}>
              <div className={styles.title}>
                <h2>Tại sao nên chọn</h2>
                <h2>Du học Hàn Quốc?</h2>
              </div>
              <div className={styles.infor_list}>
                <div className={styles.infor_item}>
                  <img src="/icons/graduation.svg" alt="graduation" />
                  <div>
                    <h3>Học bổng đa dạng và hấp dẫn</h3>
                    <p>Các trường đại học Hàn Quốc thường xuyên cấp học bổng từ 30% đến 100% học phí cho sinh viên quốc tế, đặc biệt là những bạn có thành tích học tập tốt. Đây là cơ hội lớn để giảm chi phí và tiếp cận nền giáo dục chất lượng cao.</p>
                  </div>
                </div>
                <div className={styles.infor_item}>
                  <img src="/icons/bag.svg" alt="Bag" />
                  <div>
                    <h3>Vừa học vừa làm để trang trải chi phí</h3>
                    <p>Du học sinh được phép làm thêm hợp pháp với mức thu nhập trung bình 1,2 – 1,5 triệu Won/tháng (~ 25 – 30 triệu VNĐ). Việc làm thêm không chỉ hỗ trợ tài chính mà còn giúp bạn trau dồi kỹ năng, nâng cao khả năng tiếng Hàn và tích lũy kinh nghiệm thực tế.</p>
                  </div>
                </div>
                <div className={styles.infor_item}>
                  <img src="/icons/rocket.svg" alt="rocket" />
                  <div>
                    <h3>Cơ hội nghề nghiệp rộng mở sau khi tốt nghiệp</h3>
                    <p>Sau khi ra trường, sinh viên quốc tế có thể làm việc tại các tập đoàn lớn của Hàn Quốc hoặc công ty đa quốc gia với mức lương khởi điểm 1,9 – 3,8 triệu Won/tháng (~ 40–70 triệu VNĐ). Đây là bước đệm quan trọng để phát triển sự nghiệp lâu dài.</p>
                  </div>
                </div>
                <div className={styles.infor_item}>
                  <img src="/icons/planet.svg" alt="planet" />
                  <div>
                    <h3>Môi trường sống hiện đại, cơ hội tương lai bền vững</h3>
                    <p>Hàn Quốc có nền văn hóa đặc sắc, xã hội an toàn, hiện đại và đang đối mặt với tình trạng già hóa dân số. Điều này mở ra nhu cầu nhân lực trẻ rất lớn, mang lại cho du học sinh nhiều cơ hội việc làm và định cư trong tương lai.</p>
                  </div>
                </div>
              </div>
              <div className={styles.btn} onClick={scrollToRegister}>Tham gia ngay</div>
            </div>
            <div className={styles.image}>
              <img src="/images/korea.jpg" alt="Hàn Quốc" />
            </div>
          </div>

          <div className={styles.section} style={{alignItems: "stretch"}}>
            <div className={styles.image}>
              <img src="/images/newlife.jpg" alt="New Life" />
              <img src="/images/newlife_02.jpg" alt="New Life" />
            </div>
            <div className={styles.infor}>
              <div className={styles.title}>
                <h2>Tại sao nên chọn</h2>
                <h2>New Life?</h2>
              </div>
              <div className={styles.infor_list}>
                <div className={styles.infor_item}>
                  <img src="/icons/check.svg" alt="Check" />
                  <div>
                    <p>Tư vấn chọn trường, chọn ngành đúng định hướng cá nhân.</p>
                  </div>
                </div>
                <div className={styles.infor_item}>
                  <img src="/icons/check.svg" alt="Check" />
                  <div>
                    <p>Hỗ trợ làm hồ sơ, luyện phỏng vấn visa, đảm bảo tỷ lệ đậu cao.</p>
                  </div>
                </div>
                <div className={styles.infor_item}>
                  <img src="/icons/check.svg" alt="Check" />
                  <div>
                    <p>Đào tạo tiếng Hàn chuyên sâu trước khi xuất cảnh.</p>
                  </div>
                </div>
                <div className={styles.infor_item}>
                  <img src="/icons/check.svg" alt="Check" />
                  <div>
                    <p>Kết nối với các trường đại học đối tác uy tín tại Hàn.</p>
                  </div>
                </div>
                <div className={styles.infor_item}>
                  <img src="/icons/check.svg" alt="Check" />
                  <div>
                    <p>Hỗ trợ học viên trong suốt quá trình học tập và sinh sống tại Hàn Quốc.</p>
                  </div>
                </div>
                <div className={styles.infor_item}>
                  <div>
                    <p>Du học Hàn Quốc không chỉ là hành trình học tập – đó còn là bước đệm để bạn phát triển toàn diện về tư duy, kỹ năng và tầm nhìn quốc tế. Hãy để Newlife giúp bạn biến ước mơ du học Hàn thành hiện thực!</p>
                  </div>
                </div>
              </div>
              <div className={styles.btn} onClick={scrollToRegister}>Tham gia ngay</div>
            </div>
          </div>
        </div>

        <Hotline />

        <Register ref={registerRef} />
      </div>

      <Footer />
    </>
  );
}

export default HomePage;